module.exports = __webpack_public_path__ + "static/media/icon-card.4d835f2a.svg";